import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { Ptag } from "components/core";
import {
  HeaderRow,
  MaterialTable,
  MaterialTableContainer,
} from "components/core/BaseTable/styles";

function ProTable({ headers, rows }) {
  return (
    <TableContainer
      sx={{ ...MaterialTableContainer, border: "1px solid #E4E4E4" }}
    >
      <Table sx={MaterialTable}>
        {headers && headers.length > 0 && (
          <TableHead>
            <TableRow>
              {headers.map((header, index) => (
                <TableCell
                  key={header.name || index}
                  variant="head"
                  align="center"
                  sx={{ ...HeaderRow, ...header.style }}
                >
                  {header.display_name}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
        )}
        {rows && rows.length > 0 && (
          <TableBody>
            {rows.map((row, index) => (
              <TableRow
                key={row.id || index}
                sx={{
                  "&:last-child td, &:last-child th": { border: 0 },
                }}
              >
                {headers.map(({ name }, index) => (
                  <TableCell
                    align="center"
                    component="th"
                    scope="row"
                    key={name || index}
                    sx={{
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      padding: "16px 4px",
                      background: "white",
                    }}
                  >
                    <Ptag style={{ display: "inline" }}>
                      {row[name] || "-"}
                    </Ptag>
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        )}
      </Table>
    </TableContainer>
  );
}

export default ProTable;
